import Vue from "vue";
import TaxReceiptTransformer from "@/transformers/Invoice";

import moment from "moment";

function paramsTransformer({
  page = 1,
  size,
  from,
  to,
  searchQuery,
  customer = 0,
  pageSize,
  status,
  type,
}) {
  return {
    page: page - 1,
    from: from ? moment(from).format("YYYY/MM/DD") : null,
    to: to ? moment(to).add(1, "d").format("YYYY/MM/DD") : null,
    text: searchQuery,
    customer: customer ? customer : undefined,
    size: size || pageSize || 5,
    status: status ? status : null,
    type: type || 1
    // type: type ? 2 : 1,
  };
}

function paginationTransformer({ totalItems, page, size }) {
  const next = (page + 1) * size < totalItems ? page + 2 : null;
  const previous = page + 1 > 1 ? page : null;
  const paginationInfo = {
    count: totalItems,
    next,
    previous,
  };
  return paginationInfo;
}

export default (opts) => {
  let url = `taxreceipt/taxreceipt/`;

  const { id } = opts;
  let config;

  if (id) {
    url += `${id}/`;
  } else if (opts) {
    config = {
      params: paramsTransformer(opts),
    };
  }

  return Vue.$http.get(url, config).then((response) => {
    let data = response.data;

    if (id) {
      return TaxReceiptTransformer.fetch(data);
    } else {
      const { result, ...paginationData } = response.data[0];
      const paginationInfo = paginationTransformer(paginationData);
      const taxReceipts = TaxReceiptTransformer.fetchCollection(result);

      return {
        taxReceipts,
        paginationInfo,
      };
    }
  });
};



// WEBPACK FOOTER //
// ./src/services/taxReceipt/getBilleds.js